import { OpenAPI } from "simplydo/interfaces";

import { API, APIError } from ".";
import SearchParams from "../searchParams";

export const polls = (api: API) => ({
  get(
    id: string,
    success: (data: OpenAPI.GET<"/polls/{id}">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.maybeAuthenticatedRequest("GET", `/polls/${id}`, null, success, fail);
  },
  getPolls(
    params: OpenAPI.GET<"/polls">["parameters"]["query"],
    success: (data: OpenAPI.GET<"/polls">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    const queryParams = new SearchParams(params).toSafeString();
    api.authenticatedRequest(
      "GET",
      `/polls${queryParams}`,
      null,
      success,
      fail,
    );
  },
  createPoll(
    data: OpenAPI.POST<"/polls">["requestBody"],
    success: (data: OpenAPI.POST<"/polls">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("POST", `/polls`, data, success, fail);
  },
  update(
    id: string,
    data: OpenAPI.PUT<"/polls/{id}">["requestBody"],
    success: (data: OpenAPI.PUT<"/polls/{id}">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("PUT", `/polls/${id}`, data, success, fail);
  },
  delete(
    id: string,
    success: (data: OpenAPI.DELETE<"/polls/{id}">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest("DELETE", `/polls/${id}`, null, success, fail);
  },
  submit(
    id: string,
    responses: OpenAPI.POST<"/polls/{id}/responses">["requestBody"],
    success: (data: OpenAPI.POST<"/polls/{id}/responses">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.maybeAuthenticatedRequest(
      "POST",
      `/polls/${id}/responses`,
      responses,
      success,
      fail,
    );
  },
  getResponses(
    id: string,
    success: (data: OpenAPI.GET<"/polls/{id}/responses">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/polls/${id}/responses`,
      null,
      success,
      fail,
    );
  },
  deleteResponses(
    id: string,
    success: (
      data: OpenAPI.DELETE<"/polls/{id}/responses">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/polls/${id}/responses`,
      null,
      success,
      fail,
    );
  },
  getConnections(
    id: string,
    success: (data: OpenAPI.GET<"/polls/{id}/connections">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "GET",
      `/polls/${id}/connections`,
      null,
      success,
      fail,
    );
  },
  connectExcel(
    id: string,
    success: (
      data: OpenAPI.PUT<"/polls/{id}/connect/excel">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "PUT",
      `/polls/${id}/connect/excel`,
      null,
      success,
      fail,
    );
  },
  disconnectExcel(
    id: string,
    success: (
      data: OpenAPI.DELETE<"/polls/{id}/connect/excel">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/polls/${id}/connect/excel`,
      null,
      success,
      fail,
    );
  },
  duplicate(
    id: string,
    organisationId: string,
    success: (data: OpenAPI.POST<"/polls/{id}/duplicate">["response"]) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/polls/${id}/duplicate`,
      { organisationId },
      success,
      fail,
    );
  },
  subscribeToResponses(
    id: string,
    userIds: string[],
    success: (
      data: OpenAPI.POST<"/polls/{id}/responses/subscribe">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "POST",
      `/polls/${id}/responses/subscribe`,
      { userIds },
      success,
      fail,
    );
  },
  unsubscribeFromResponses(
    id: string,
    userIds: string[],
    success: (
      data: OpenAPI.DELETE<"/polls/{id}/responses/subscribe">["response"],
    ) => void,
    fail: (error: APIError) => void,
  ) {
    api.authenticatedRequest(
      "DELETE",
      `/polls/${id}/responses/subscribe`,
      { userIds },
      success,
      fail,
    );
  },
});
